import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import SchemaOrg from '../components/SchemaOrg';

const NosotrosPage: React.FC = () => {
  return (
    <div className="pt-32 pb-24">
      <SEO
        title="Nosotros | Quiénes Somos - LQP Global"
        description="Conocé al equipo detrás de LQP Global. +150 empresas confían en nosotros para transformar el caos digital en sistemas escalables. Tu socio tecnológico estratégico."
        keywords="equipo lqp global, agencia desarrollo software, quienes somos, empresa tecnología argentina, desarrollo web profesional"
        url="https://lqpglobal.com/nosotros"
      />
      <SchemaOrg type="organization" />

      <div className="container mx-auto px-6">
        {/* Breadcrumbs */}
        <nav aria-label="Breadcrumb" className="mb-8">
          <ol className="flex items-center gap-2 text-sm text-gray-500" itemScope itemType="https://schema.org/BreadcrumbList">
            <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <Link to="/" className="hover:text-white transition-colors" itemProp="item">
                <span itemProp="name">Inicio</span>
              </Link>
              <meta itemProp="position" content="1" />
            </li>
            <span>/</span>
            <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
              <span className="text-gray-400" itemProp="name">Nosotros</span>
              <meta itemProp="position" content="2" />
            </li>
          </ol>
        </nav>

        <section className="grid lg:grid-cols-2 gap-16 items-center mb-32">
          <div className="relative">
            <div className="absolute -top-12 -left-12 w-48 h-48 bg-orange-500/10 blur-[80px] rounded-full" aria-hidden="true" />
            <div className="inline-block px-4 py-1 rounded-full bg-orange-500/10 border border-orange-500/20 text-xs font-bold text-orange-500 mb-6 uppercase tracking-widest">
              Nuestra Historia
            </div>
            <h1 className="text-5xl md:text-7xl font-black text-gradient mb-8 leading-tight">
              El Orden <br /> Detrás del <br /> <span className="text-orange-500">Éxito</span>
            </h1>
            <p className="text-gray-400 text-lg leading-relaxed mb-6">
              LQP Global nació de una observación simple: las empresas no mueren por falta de ventas, sino por exceso de desorden.
            </p>
            <p className="text-gray-400 text-lg leading-relaxed">
              Comenzamos ayudando a negocios locales a digitalizar sus procesos y hoy somos el socio tecnológico de más de 150 empresas que han transformado el caos en escalabilidad real.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-6">
            <div className="aspect-square glass rounded-[2.5rem] flex flex-col items-center justify-center p-8 border-orange-500/10 hover:border-orange-500/30 transition-all">
              <span className="text-5xl mb-4" aria-hidden="true">🌍</span>
              <span className="text-white font-bold">Visión Global</span>
            </div>
            <div className="aspect-square glass rounded-[2.5rem] flex flex-col items-center justify-center p-8 border-blue-500/10 hover:border-blue-500/30 transition-all mt-12">
              <span className="text-5xl mb-4" aria-hidden="true">💡</span>
              <span className="text-white font-bold">Innovación</span>
            </div>
          </div>
        </section>

        <section className="mb-32" aria-labelledby="filosofia-title">
          <h2 id="filosofia-title" className="text-4xl font-bold mb-16 text-center">Nuestra Filosofía</h2>
          <div className="grid md:grid-cols-3 gap-12">
            {[
              {
                title: "Tecnología Humana",
                desc: "El software debe servir a las personas, no al revés. Priorizamos la usabilidad y la adopción real del sistema."
              },
              {
                title: "Orden Escalable",
                desc: "Diseñamos pensando en el mañana. Tu sistema de hoy debe soportar 10 veces el volumen de mañana."
              },
              {
                title: "Compromiso Real",
                desc: "No somos proveedores externos, somos tu departamento de IT estratégico. Tu éxito es el nuestro."
              }
            ].map((item, i) => (
              <article key={i} className="text-center group">
                <div className="w-16 h-16 bg-white/5 rounded-2xl mx-auto mb-6 flex items-center justify-center border border-white/10 group-hover:border-orange-500/50 transition-colors">
                  <span className="text-2xl font-black text-orange-500">0{i+1}</span>
                </div>
                <h3 className="text-xl font-bold mb-4">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="glass p-12 md:p-20 rounded-[3rem] border-white/10 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-tr from-orange-600/10 to-transparent" aria-hidden="true" />
          <h2 className="text-4xl font-bold mb-8 relative z-10">¿Listo para dar el siguiente paso?</h2>
          <p className="text-gray-400 mb-12 max-w-2xl mx-auto relative z-10 text-lg">
            Estamos buscando nuestro próximo caso de éxito. Queremos ayudarte a construir el sistema que tu negocio merece.
          </p>
          <Link
            to="/contacto"
            className="inline-block px-12 py-5 bg-white text-black font-black rounded-2xl transition-all shadow-2xl hover:scale-105 active:scale-95 relative z-10"
          >
            HABLEMOS HOY
          </Link>
        </section>
      </div>
    </div>
  );
};

export default NosotrosPage;
